import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase } from '@digibricks/domains';
export var VALIDATE_PUBLIC_FILE_URL_USE_CASE = 'VALIDATE_PUBLIC_FILE_URL_USE_CASE';
export var ValidatePublicFileUrlUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(ValidatePublicFileUrlUseCase, _UseCase);

  var _super = _createSuper(ValidatePublicFileUrlUseCase);

  function ValidatePublicFileUrlUseCase(fileStorageRepository) {
    var _this;

    _classCallCheck(this, ValidatePublicFileUrlUseCase);

    _this = _super.call(this);
    _this.fileStorageRepository = fileStorageRepository;
    return _this;
  }

  _createClass(ValidatePublicFileUrlUseCase, [{
    key: "validateUrl",
    value: function validateUrl(url) {
      try {
        // Is Link
        if (url.startsWith('http')) {
          return true;
        } // Is File Link


        var allowedExtensions = ['.pdf'];
        var urlExtension = url.split('.').pop();
        return allowedExtensions.includes(".".concat(urlExtension));
      } catch (_unused) {
        return false;
      }
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.validateUrl(input.url)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", Result.fail('Invalid URL format'));

              case 2:
                _context.next = 4;
                return this.fileStorageRepository.validatePublicFileUrl(input);

              case 4:
                return _context.abrupt("return", _context.sent);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return ValidatePublicFileUrlUseCase;
}(UseCase);